// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';
import {f7, f7ready} from 'framework7-vue';
import Dom7 from 'dom7';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  show_loader: false,
  processing: false,
  date_format: 'YYYY-MM-DD',
};

// getters
const getters = {
  ...BaseModule.getters,
  date_format(state, getters, rootState, rootGetters) {
    return state.date_format;
  },
  is_browser(state, getters, rootState, rootGetters) {
    return f7.device.desktop || f7.device.androidChrome;
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  processing ({state, commit, dispatch, getters, rootState}, payload) {
      commit('processing', payload);
  },
  scrollToTop({state, commit, dispatch, getters, rootState}) {
    Dom7('.page-current .page-content').scrollTop(0, 300);
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  show_loader (state) {
      state.show_loader = true;
  },
  hide_loader (state) {
      state.show_loader = false;
  },
  processing (state, value) {
      state.processing = value;
  },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
